import './Header.scss';

import cn from 'classnames';
import React from 'react';

import useBreakpoints from '@/common/hooks/useBreakpoints';
import BottomHeader from '@/ebat/components/blocks/Header/BottomHeader/BottomHeader';
import LastSearch from '@/ebat/components/blocks/Header/LastSearch/LastSearch';
import Drawer from '@/ebat/components/blocks/Header/MenuComponents/Drawer/Drawer';
import FixedPanel from '@/ebat/components/blocks/Header/MenuComponents/FixedMenu/FixedMenu';
import MiniCart from '@/ebat/components/blocks/Header/MiniCart/MiniCart';
import TopHeader from '@/ebat/components/blocks/Header/TopHeader/TopHeader';
import HeaderAccessesContextProvider from '@/ebat/contexts/Header/HeaderAccessesContext/HeaderAccessesContext';
import {
  MENU_NAME_SEARCH,
  MENU_TYPE_EXTERNAL,
  useHeaderMenuContext,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import { HeaderDefaultProps, HeaderPropTypes } from './Header.proptypes';

const Header = ({ noBottomHeader }) => {
  const { isOpen } = useHeaderMenuContext();
  const isSearchOpen = isOpen({
    name: MENU_NAME_SEARCH,
    type: MENU_TYPE_EXTERNAL,
  });
  const { isMaxDesktop } = useBreakpoints();

  return (
    <HeaderAccessesContextProvider>
      <header id="header" className="header">
        <TopHeader
          className="header__top"
          mobileItemClassName="header__mobile-item"
          desktopItemClassName="header__desktop-item"
          showSearchBar={!isMaxDesktop}
        />
        {!noBottomHeader && (
          <BottomHeader
            className={cn('header__bottom', {
              'header__bottom--search-open': isSearchOpen,
            })}
            mobileItemClassName="header__mobile-item"
            desktopItemClassName="header__desktop-item"
            showSearchBar={isMaxDesktop}
          />
        )}
        <div
          className={cn('header__spacer', {
            'header__spacer--search-open': isSearchOpen,
          })}
        />
        <Drawer />
        <FixedPanel />
        <LastSearch />
        <MiniCart />
      </header>
    </HeaderAccessesContextProvider>
  );
};

Header.defaultProps = {
  ...HeaderDefaultProps,
};

Header.propTypes = {
  ...HeaderPropTypes,
};

export default Header;
